import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { Skeleton } from '@achra/ui/skeleton';
import { PRICING_GRID } from '../feature-row/feature-row-skeleton';
function GrandTotalRowCatalogSkeleton() {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = cn("grid", PRICING_GRID.responsive, "items-center");
    t1 = <div className={cn("bg-background flex min-h-18 items-center px-4 lg:px-6", "sticky left-0 z-10 lg:static")}><Skeleton className="bg-border h-5 w-40" /></div>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className={t0}>{t1}<div className="flex min-h-18 min-w-0 items-center justify-center px-4 lg:hidden"><Skeleton className="bg-border h-4 w-16" /></div>{Array.from({
        length: 4
      }).map(_temp)}</div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function _temp(_, i) {
  return <div key={i} className="hidden min-h-18 min-w-0 items-center justify-center px-6 lg:flex"><Skeleton className="bg-border h-4 w-16" /></div>;
}
export { GrandTotalRowCatalogSkeleton };